module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showAdminModal === 'addUser',
      "size": "lg",
      "lazy": true
    },
    on: {
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [_c('h4', [_vm._v("Добавить пользователя")]), _vm._v(" "), _c('span', {
    staticClass: "small help-block"
  }, [_vm._v("Перед добавлением пользователя создайте техцентр если он не существует")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Загружаем..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.firstname.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label",
    attrs: {
      "for": "user-firstname"
    }
  }, [_vm._v("Имя")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userData.firstname),
      expression: "userData.firstname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-firstname",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userData.firstname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "firstname", $event.target.value.trim())
      }, function($event) {
        _vm.$v.userData.firstname.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.userData.firstname.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Имя обязательно должно быть указано, минимум " + _vm._s(_vm.$v.userData.lastname.$params.minLength.min) + " символа")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.lastname.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label",
    attrs: {
      "for": "user-lastname"
    }
  }, [_vm._v("Фамилия")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userData.lastname),
      expression: "userData.lastname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-lastname",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userData.lastname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "lastname", $event.target.value.trim())
      }, function($event) {
        _vm.$v.userData.lastname.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.userData.lastname.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Фамилия обязательно должна быть указана")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.email.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label",
    attrs: {
      "for": "user-email"
    }
  }, [_vm._v("Электронная почта")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userData.email),
      expression: "userData.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-email",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userData.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "email", $event.target.value.trim())
      }, function($event) {
        _vm.$v.userData.email.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.userData.email.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Адрес электронной почты обязателен и должен быть валидным")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary ml-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.notifyEmail),
      expression: "userData.notifyEmail"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.userData.notifyEmail) ? _vm._i(_vm.userData.notifyEmail, null) > -1 : (_vm.userData.notifyEmail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.userData.notifyEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.userData.notifyEmail = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.userData.notifyEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.userData, "notifyEmail", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  }), _vm._v(" "), (_vm.userData.notifyEmail) ? _c('small', [_vm._v("отправить")]) : _c('small', [_vm._v("не отправлять")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Отправить письмо с регистрационными данными")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.phone.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label",
    attrs: {
      "for": "user-phone"
    }
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("+7")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userData.phone),
      expression: "userData.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-phone",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userData.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "phone", $event.target.value.trim())
      }, function($event) {
        _vm.$v.userData.phone.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.$v.userData.phone.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Телефон обязателен и должен состоять из 10 цифр")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.password.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label",
    attrs: {
      "for": "new-password"
    }
  }, [_vm._v("Пароль")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": _vm.passwordType,
      "id": "new-password",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.userData.password
    },
    on: {
      "input": _vm.setPassword
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.passwordType === 'password') ? _c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.passwordType = 'text'
      }
    }
  }) : _c('i', {
    staticClass: "fa fa-eye-slash",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.passwordType = 'password'
      }
    }
  })])]), _vm._v(" "), (_vm.$v.userData.password.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Пароль обязателен, минимум " + _vm._s(_vm.$v.userData.password.$params.minLength.min) + " символов")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-6"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.generatePassword($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Сгенерировать")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label"
  }, [_vm._v("Компании")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.additionalData.companies,
      "searchable": true,
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Компании не выбран",
      "track-by": "id",
      "label": "name"
    },
    model: {
      value: (_vm.userData.companies),
      callback: function($$v) {
        _vm.$set(_vm.userData, "companies", $$v)
      },
      expression: "userData.companies"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.techcenters.$error
    }
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label"
  }, [_vm._v("Техцентры")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.additionalData.techcenters,
      "searchable": true,
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Техцентры не выбран",
      "track-by": "id",
      "label": "name"
    },
    model: {
      value: (_vm.userData.techcenters),
      callback: function($$v) {
        _vm.$set(_vm.userData, "techcenters", $$v)
      },
      expression: "userData.techcenters"
    }
  }), _vm._v(" "), (_vm.$v.userData.techcenters.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Как минимум один техцентр должен быть выбран")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.roles.$error
    }
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label"
  }, [_vm._v("Роли пользователя")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.additionalData.roles,
      "searchable": true,
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Роли не выбран",
      "track-by": "id",
      "label": "description"
    },
    model: {
      value: (_vm.userData.roles),
      callback: function($$v) {
        _vm.$set(_vm.userData, "roles", $$v)
      },
      expression: "userData.roles"
    }
  }), _vm._v(" "), (_vm.$v.userData.roles.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Роль должна быть указана")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [_vm._v("Добавить пользователя")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-83445740"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalAdminAddUser.vue
// module id = 1055
// module chunks = 1